import get from './get';
import update from './update';
import updateImage from './updateImage';
import deleteImage from './deleteImage';

export default [get, update, updateImage, deleteImage];
